import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";

export const getSession = (state: ApplicationState) => state.context.session;

export const getFulfillmentLabel = (state: ApplicationState) => {
    const { fulfillmentMethod, isAuthenticated, rememberMe, isGuest, shipToId, pickUpWarehouse } = getSession(state);
    const shipToState = getShipToState(state, shipToId);
    const { value: shipTo } = shipToState;

    let addressLabel = "Ship";
    if (fulfillmentMethod === FulfillmentMethod.Ship && (isAuthenticated || rememberMe) && !isGuest && shipTo) {
        let label = shipTo.label;
        if (label.indexOf("Use Billing Address") > -1) {
            label = label.replace("Use ", "");
        } else {
            label = `${shipTo.customerSequence} - ${shipTo.fullAddress}`;
        }
        addressLabel = translate("Ship to {0}", `${label}`);
    } else if (fulfillmentMethod === FulfillmentMethod.PickUp) {
        addressLabel = translate(
            "Pick up {0}",
            pickUpWarehouse ? `at ${pickUpWarehouse.description || pickUpWarehouse.name}` : "",
        );
    }

    return addressLabel;
};

export const getCustomerLabel = (state: ApplicationState) => {
    const { isAuthenticated, rememberMe, isGuest, billToId } = getSession(state);
    const billToState = getBillToState(state, billToId);
    const { value: billTo } = billToState;

    let customerLabel = "";
    if ((isAuthenticated || rememberMe) && !isGuest && billTo) {
        customerLabel = `${billTo.customerNumber} - ${billTo.companyName}`;
    }
    return customerLabel;
};
